import { createEvent, restore, sample } from 'effector'
import { notification } from 'antd'
import { fx } from 'src/libs'
import { Partner, PartnerEdit } from './types'
import { $params } from 'src/features/router'
import { getPartnerByClientId } from 'src/pages/clients/details/model'
import { partnerStatusHumanToNumber } from '../const'

export const partnerProfileMounted = createEvent()
export const parentPartnerMounted = createEvent()
export const setPartnerProfile = createEvent<Partner>()
export const setClientPartner = createEvent<{ id: string; firstName: string }>()

export const $partnerProfile = restore<Partner>(setPartnerProfile, {
  id: '',
  key: '',
  email: '',
  registeredAt: '',
  fullName: '',
  status: '',
  activeClients: 0,
  sumLots: 0,
  sumCommissions: 0,
  sumCommissionsLevelTwo: null,
  sumCommissionsLevelThree: null,
  sumCashback: 0,
  sumDeposits: 0,
  sumWithdrawals: 0,
  withdrawalAmount: 0,
  partnerClientsCount: 0,
  stoppedPaymentCommissionsAt: null,
  humanStoppedPaymentCommissionsAt: null,
  createdAt: '',
  updatedAt: '',
  client: {
    email: '',
    fullName: '',
    country: '',
    isTest: false,
    isPremium: false,
  },
  partnerClients: [],
})
export const submitEditPartner = createEvent<PartnerEdit>()
export const submitChangeStatus = createEvent<{ id: string; status: string }>()

export const $clientPartner = restore(setClientPartner, {
  id: '',
  firstName: '',
})

export const getPartner = fx<void, Partner>({
  method: 'GET',
  url: '/partner/',
})
export const updatePartner = fx<any, Partner>({
  method: 'PUT',
  url: '/partner/',
})

sample({
  clock: partnerProfileMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.partnerID
    }
    return {
      url: `/partner/${id}`,
      query: {
        populate: JSON.stringify([
          'Partner.sumCommissionsLevelTwo',
          'Partner.sumCommissionsLevelThree',
        ]),
      },
    }
  },
  target: getPartner,
})

sample({
  clock: parentPartnerMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.partnerID
    }
    return {
      url: `/partner`,
      query: {
        where: '{partner}',
      },
    }
  },
  target: getPartner,
})

sample({
  clock: submitEditPartner,
  source: $params,
  fn: (params, partner) => {
    return {
      url: `/partner/${params?.partnerID}`,
      body: { id: partner.id, isStopped: partner.isStopped },
    }
  },
  target: updatePartner,
})

sample({
  clock: submitChangeStatus,
  source: $params,
  fn: (params, { id, status }) => ({
    url: `/partner/${params?.partnerID}`,
    body: { id, status: partnerStatusHumanToNumber(status) },
  }),
  target: updatePartner,
})

sample({
  clock: updatePartner.doneData,
  fn: (doneData) => doneData.body,
  target: setPartnerProfile,
})

updatePartner.doneData.watch(() => {
  notification.success({ message: 'Status updated' })
})

sample({
  clock: getPartner.doneData,
  fn: (doneData) => {
    const id = doneData.body.id
    return {
      url: `/client/${id}/partner`,
    }
  },
  target: getPartnerByClientId,
})

sample({
  clock: getPartnerByClientId.doneData,
  fn: (doneData) => doneData.body,
  target: setClientPartner,
})

sample({
  clock: getPartner.doneData,
  fn: (doneData) => doneData.body,
  target: setPartnerProfile,
})
